export async function authenticate(req) {
  const token = await window.authorise()

  req.headers = req.headers || {}

  req.headers["Authorization"] = `Bearer ${token}`

  return req
}
